import { GroupIds } from "@/configuration/group-ids";
import type { CustomerSmsRoutingConfig } from "@/customer-interface/sms-routing";

export const NIMBUS_TWILIO_NUMBER = "+14783304681";
export const NIMBUS_SANDBOX_TWILIO_NUMBER = "+17577865078";

export const nimbusSmsRoutingConfig = {
  groups: [
    {
      groupId: GroupIds.NIMBUS_LIVE,
      inboundPhoneNumbers: [NIMBUS_TWILIO_NUMBER],
      defaultSenderPhoneNumber: NIMBUS_TWILIO_NUMBER,
      clinicPhone: { backupPhoneNumber: "+14787442445" },
    },
    {
      groupId: GroupIds.NIMBUS_LIVE_SANDBOX,
      inboundPhoneNumbers: [NIMBUS_SANDBOX_TWILIO_NUMBER],
      defaultSenderPhoneNumber: NIMBUS_SANDBOX_TWILIO_NUMBER,
      clinicPhone: { backupPhoneNumber: "+14787442445" },
    },
  ],
} as const satisfies CustomerSmsRoutingConfig;
